// Only themes are allowed to import scss files.
// eslint-disable-next-line import/no-unassigned-import
import '../../../../../scss/themes/default/default.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { markenStandortSelector } from '../../../../../modules/selectors/standort/markenStandort';
import { ExternalEventLink, InternalLink } from '../../../form-elements/Link';
import { linksFooterSelector } from '../../../../../modules/selectors/standort/theme';
import LinkSelector from '../../../Header/LinkSelector';
import { CookieSettingsButton } from '../../../OneTrust/CookieSettingsButton';
import WiderrufModal from '../../../Widerruf/WiderrufModal';
import Button from '../../../form-elements/Button';

function APSFooter() {
    const markenStandort = useSelector(markenStandortSelector);
    const links = useSelector(linksFooterSelector);

    return (
        <section className="uk-section uk-section-secondary uk-section-small">
            <div className="uk-container">
                <div
                    className="uk-grid uk-grid-row-medium uk-grid-column-small uk-child-width-1-1 uk-child-width-1-2@s"
                    data-uk-grid=""
                >
                    <div>
                        <h4 className="uk-text-uppercase uk-text-normal"><strong>Kontakt</strong></h4>
                        <ul className="uk-list">
                            <li>{markenStandort.anschrift?.firma}</li>
                            <li>
                                <ExternalEventLink
                                    to={`tel:${markenStandort.anschrift?.telefon}`}
                                    action="Klick-Telefon"
                                    category="Anfrage"
                                    label={markenStandort.anschrift?.telefon}
                                    ariaLabel={`Telefonnummer: ${markenStandort.anschrift?.telefon}`}
                                >
                                    <i className="fa fa-phone" /> {markenStandort.anschrift?.telefon}
                                </ExternalEventLink>
                            </li>
                            <li>
                                <ExternalEventLink
                                    to={`mailto:${markenStandort.anschrift?.email}`}
                                    category="Anfrage"
                                    action="Klick-Email"
                                    label={markenStandort.anschrift?.email}
                                >
                                    <i className="fa fa-envelope-o" /> {markenStandort.anschrift?.email}
                                </ExternalEventLink>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="uk-text-uppercase uk-text-normal"><strong>Rechtliches</strong></h4>
                        <ul className="uk-list">
                            <li>
                                <LinkSelector to={links.impressum.to} type={links.impressum.type} label={links.impressum.label} />
                            </li>
                            <li>
                                <LinkSelector to={links.datenschutz.to} type={links.datenschutz.type} label={links.datenschutz.label} />
                            </li>
                            <li>
                                <InternalLink to="/copyright">Copyright</InternalLink>
                            </li>
                            <li>
                                <CookieSettingsButton />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default APSFooter;


